import React from 'react'

export const SparkleIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg className={className} viewBox="16 12 56 56" fill="currentColor" aria-hidden="true">
        <path d="M57.44 22.6396C57.44 25.1139 59.4457 27.1196 61.92 27.1196C59.4457 27.1196 57.44 29.1254 57.44 31.5996C57.44 29.1254 55.4342 27.1196 52.96 27.1196C55.4342 27.1196 57.44 25.1139 57.44 22.6396Z" />
        <path d="M43.9998 19.8398C43.9998 30.9739 53.0258 39.9998 64.1598 39.9998C53.0258 39.9998 43.9998 49.0258 43.9998 60.1598C43.9998 49.0258 34.9739 39.9998 23.8398 39.9998C34.9739 39.9998 43.9998 30.9739 43.9998 19.8398Z" />
    </svg>
)

const StrokeIcon: React.FC<{ className?: string; children: React.ReactNode }> = ({
    className,
    children,
}) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {children}
    </svg>
)

export const MicIcon: React.FC<{ className?: string }> = ({ className }) => (
    <StrokeIcon className={className}>
        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <path d="M12 19v3" />
    </StrokeIcon>
)

export const MicOffIcon: React.FC<{ className?: string }> = ({ className }) => (
    <StrokeIcon className={className}>
        <path d="m2 2 20 20" />
        <path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" />
        <path d="M5 10v2a7 7 0 0 0 12 5" />
        <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" />
        <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
        <path d="M12 19v3" />
    </StrokeIcon>
)

export const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
    <StrokeIcon className={className}>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </StrokeIcon>
)
